module.exports = __webpack_public_path__ + "img/project_19.47378403.jpg";